import styled from 'styled-components'

export const Container = styled.header`
  background-color: #084F43;
  border-bottom: 1px solid #FFFFFF1A;
  padding: 16px;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 2;

  &.blank {
    background-color: #FFF;
    border-color: #EEE;

    figure {
      max-width: 152px;
    }

    span {
      border-radius: 34px;
      font-weight: 700;
      padding: 8px 24px;
    }
  }

  @media (min-width: 912px) {
    padding-inline: 76px;
  }

  @media (max-width: 568px) {
    &.blank {
      a {
        padding: 0;

        span {
          padding: 4px 16px;
        }
      }
    }
  }
`

export const Content = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  margin-inline: auto;
  max-width: 1366px;

  & > a {
    font-size: 1rem;
    line-height: 140%;
    padding: 8px 32px;
  }

  @media (max-width: 568px) {
    & > a {
      padding: 4px 16px;
    }
  }
`
